import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-alterar-senha',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './modal-alterar-senha.component.html',
  styleUrls: ['./modal-alterar-senha.component.scss'],
})
export class ModalAlterarSenhaComponent implements OnInit {
  senha: string = '';

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    // console.log('alterar senha');
  }

  confirmarSenha() {
    this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
